import { IdaLogoSvg } from "./IdaLogo.js";
import MitIdaLogoSvg from "./MitIdaLogo.js";
import { IdaForsikringLogoSvg } from "./IdaForsikringLogo.js";
const BrandsList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IdaForsikringLogo: IdaForsikringLogoSvg,
  IdaLogo: IdaLogoSvg,
  MitIdaLogo: MitIdaLogoSvg
}, Symbol.toStringTag, { value: "Module" }));
export {
  BrandsList as B,
  IdaForsikringLogoSvg as IdaForsikringLogo,
  IdaLogoSvg as IdaLogo,
  MitIdaLogoSvg as MitIdaLogo
};
